module.exports = __webpack_public_path__ + "img/program-icon.a0bd3f21.svg";